import { useTranslation } from 'next-i18next'

import ROUTES from '~/shared/constants/routes.const'

import { NavigationElement } from './MediaPageWrapperNav.types'

export default function useMediaPageWrapperNav(): Array<{ label: string; href: string; key: NavigationElement }> {
  const { t } = useTranslation('media')

  return [
    {
      label: t('navNews'),
      href: ROUTES.MEDIA_NEWS,
      key: NavigationElement.NEWS,
    },
    // TODO: Enable once first press release gets added.
    // {
    //   label: t('navPressReleases'),
    //   href: ROUTES.MEDIA_PRESS_RELEASES,
    //   key: NavigationElement.PRESS_RELEASES,
    // },
    {
      label: t('navMediabank'),
      href: ROUTES.MEDIA_MEDIABANK,
      key: NavigationElement.MEDIABANK,
    },
  ]
}
